import { Injectable } from '@angular/core';
import { 
  Router,
  ActivatedRoute,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot } from '@angular/router';

import { AuthService } from './auth/auth.service';

@Injectable()
export class RootGuard {

  constructor(
    private router: Router,
    private authService: AuthService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authService.signedIn) {
      this.router.navigate(["/root"]);
      return false;
    } else {
      return true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/root-guard.service.ts